import { Nullable } from '@/shared/types/app.types'

export interface ConfigurationBillableConceptGroupsModalState {
    id: Nullable<number>
    name: string
    code: string
    active: boolean
}
export const initialConfigurationBillableConceptGroupsModalState =
    (): ConfigurationBillableConceptGroupsModalState => ({
        id: null,
        name: '',
        code: '',
        active: true
    })
